import api from '../token';

export const AddProduto = async (dados) => {
  try {
    const response = await api.post('/addProduto', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};






